export type RNWindowType = typeof window & {
  ReactNativeWebView?: {
    postMessage(msg: string): void;
  };
};

export const RNWindow = window as RNWindowType;
